import React from 'react';

import TableAntd from '../../../Components/TableAntd/TableAntd';

export default function VehicleTypeList() {
  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'name',
        title: 'Nome',
        ...getColumnSearchProps('name', 'Nome'),
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortDirections: ['descend', 'ascend'],
      },
    ];
    return columns;
  };

  return (
    <TableAntd
      columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
      routePermissions="VehicleType"
      toggleStatusRoute="VehicleType"
      requestName="VehicleType"
      route="/TipoVeiculo"
      cdPage="id"
      btnNew={true}
    />
  );
}
